type Nullable<T> = T | null;

export enum ServiceTypes {
  NHS = 'NHS',
  PRIVATE = 'Private',
  Consultation = 'Consultation'
}

interface SearchResult {
  id: string;
  title: string;
  keywords: string;
}

export interface Service {
  _id: string;
  title: string;
  description: string;
  type: ServiceTypes;
  keywords: string[];
  avatar: string;
  avatar_url: string;
}

interface MultiServiceResponse extends Service {
  offered_by_pharmacy_count: number;
}

export interface CreateService {
  title: string;
  description: string;
  avatar: string;
  type: ServiceTypes;
  keywords: string[];
}

export interface State {
  services: MultiServiceResponse[];
  service: Nullable<Service>;
  searchResults: SearchResult[];
  total: number;
  isLoading: boolean;
  isUpdating: boolean;
  isCreating: boolean;
  updateError: any;
  createError: any;
}

export enum ActionTypes {
  GET_SERVICES = 'GET_SERVICES',
  GET_SERVICES_SUCCESS = 'GET_SERVICES_SUCCESS',
  GET_SERVICES_FAILURE = 'GET_SERVICES_FAILURE',

  SEARCH_SERVICES = 'SEARCH_SERVICES',
  SEARCH_SERVICES_SUCCESS = 'SEARCH_SERVICES_SUCCESS',
  SEARCH_SERVICES_FAILURE = 'SEARCH_SERVICES_FAILURE',

  CLEAR_SEARCH_RESULTS = 'CLEAR_SEARCH_RESULTS',

  GET_SERVICE = 'GET_SERVICE',
  GET_SERVICE_SUCCESS = 'GET_SERVICE_SUCCESS',
  GET_SERVICE_FAILURE = 'GET_SERVICE_FAILURE',

  UPDATE_SERVICE = 'UPDATE_SERVICE',
  UPDATE_SERVICE_SUCCESS = 'UPDATE_SERVICE_SUCCESS',
  UPDATE_SERVICE_FAILURE = 'UPDATE_SERVICE_FAILURE',
  CLEAR_UPDATE_ERROR = 'CLEAR_UPDATE_ERROR',

  CREATE_SERVICE = 'CREATE_SERVICE',
  CREATE_SERVICE_SUCCESS = 'CREATE_SERVICE_SUCCESS',
  CREATE_SERVICE_FAILURE = 'CREATE_SERVICE_FAILURE',
  CLEAR_CREATE_ERROR = 'CLEAR_CREATE_ERROR'
}
